import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { downloadFile } from '../../../consumers/backendConsumer';
import { AuthContext } from '../../../hooks/context/authContext';
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest';
import { usePostRequest } from '../../../hooks/usePostRequest/usePostRequest';
import {
    actualizarClaseModeloAPI,
    listarRubricasEvaluadorClaseModeloAPI,
} from '../../../consumers/backendApisUrls';

const ROL_GESTION_TRASLADOS_PROMOCIONES = 83;
const ESTADO_OBSERVADO = 13;
const ESTADO_APTO = 63;
const ESTADO_NO_APTO = 64;
const valor = (...valores) => valores.find(v => v !== undefined && v !== null && v !== '') ?? '';
const data = response => response?.data?.Data ?? response?.data?.data ?? response?.data ?? [];

const RevisionClaseModelo = ({ toggleModal, refreshPage, postulante = {} }) => {
    const { state } = useContext(AuthContext);
    const puedeRevisar = (state?.roleIds ?? [])
        .map(Number)
        .includes(ROL_GESTION_TRASLADOS_PROMOCIONES);

    const [executeGet] = useGetRequest();
    const [executePost] = usePostRequest();
    const [rubricas, setRubricas] = useState([]);
    const [mostrarObservacion, setMostrarObservacion] = useState(false);
    const [motivo, setMotivo] = useState('');
    const [enviando, setEnviando] = useState(false);

    const idPostulante = Number(valor(postulante.idPostulante, postulante.IdPostulante, 0));
    const idClaseModelo = Number(valor(postulante.idClaseModelo, postulante.IdClaseModelo, 0));

    useEffect(() => {
        if (!puedeRevisar || !idPostulante) return;
        executeGet(listarRubricasEvaluadorClaseModeloAPI(idPostulante)).then(response => {
            const rows = data(response);
            setRubricas(Array.isArray(rows) ? rows : []);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idPostulante, puedeRevisar]);

    const registrarResultado = async (idEstado, motivoObservado = null) => {
        if (!puedeRevisar) {
            toast.warning('No tienes permisos para revisar la clase modelo.');
            return;
        }
        if (idEstado === ESTADO_OBSERVADO && !String(motivoObservado || '').trim()) {
            toast.warning('Ingresa el motivo de la observación.');
            return;
        }

        if (!idClaseModelo) {
            toast.error('No se encontró la programación de Clase Modelo a actualizar.');
            return;
        }

        setEnviando(true);
        try {
            const response = await executePost(actualizarClaseModeloAPI(), {
                idClaseModelo: Number(idClaseModelo),
                comentarioEvaluador: valor(postulante.comentarioEvaluador, postulante.ComentarioEvaluador, null),
                idPostulante,
                motivoObservado: motivoObservado ? motivoObservado.trim() : null,
                idEstadoPostulacion: idEstado,
            });
            if (response?.response?.status >= 400) {
                toast.error(response?.response?.data?.Message ?? response?.response?.data?.message ?? 'No se pudo registrar el resultado.');
                return;
            }
            toast.success(
                idEstado === ESTADO_OBSERVADO ? 'Observación registrada correctamente.' :
                    idEstado === ESTADO_APTO ? 'Resultado Apto registrado correctamente.' :
                        'Resultado No apto registrado correctamente.'
            );
            refreshPage && refreshPage();
            toggleModal && toggleModal();
        } finally {
            setEnviando(false);
        }
    };

    const ultimaRubrica = rubricas[0];

    return (
        <GenericModal showModal={toggleModal} titulo="Clase modelo Revisión GDH" width="900px">
            <Container>
                {!puedeRevisar ? (
                    <div className="text-center py-5">Esta vista corresponde a la revisión de Clase Modelo por GDH.</div>
                ) : (
                    <>
                        <CampaignBar>{valor(postulante.nombreConvocatoria, 'Nombre campaña')} - Clase modelo Revisión GDH</CampaignBar>

                        <Grid>
                            <Field><label>Nombre del candidato</label><ReadOnly>{valor(postulante.nombrePostulante, postulante.NombrePostulante, '-')}</ReadOnly></Field>
                            <Field><label>DNI</label><ReadOnly>{valor(postulante.dni, postulante.Dni, '-')}</ReadOnly></Field>
                            <Field><label>Puesto actual</label><ReadOnly>{valor(postulante.desCargo, postulante.DesCargo, '-')}</ReadOnly></Field>
                        </Grid>

                        <Divider />
                        <SectionTitle>Datos de programación</SectionTitle>
                        <Grid>
                            <Field><label>Sede evaluadora</label><ReadOnly>{valor(postulante.desSedeEvaluadora, postulante.DesSedeEvaluadora, postulante.idSedeEvaluadora, '-')}</ReadOnly></Field>
                            <Field><label>Responsable evaluador</label><ReadOnly>{valor(postulante.nombreEmpleadoEvaluador, postulante.NombreEmpleadoEvaluador, '-')}</ReadOnly></Field>
                            <Field><label>Sede de origen</label><ReadOnly>{valor(postulante.desSedeOrigen, postulante.DesSedeOrigen, postulante.idSedeOrigen, '-')}</ReadOnly></Field>
                            <Field><label>Fecha límite</label><ReadOnly>{valor(postulante.fechaLimiteClaseModelo, postulante.FechaLimiteClaseModelo, '-')}</ReadOnly></Field>
                        </Grid>

                        <Divider />
                        <SectionTitle>Rúbrica remitida</SectionTitle>

                        {ultimaRubrica
                            ? <FileRow onClick={() => downloadFile(
                                state.token,
                                ultimaRubrica.Path ?? ultimaRubrica.path,
                                ultimaRubrica.OriginalFileName ?? ultimaRubrica.originalFileName
                            )}>
                                <u>{ultimaRubrica.OriginalFileName ?? ultimaRubrica.originalFileName}</u>
                            </FileRow>
                            : <div>No se encontró una rúbrica remitida.</div>
                        }

                        <div className="mt-3">
                            <label>Comentarios del evaluador</label>
                            <ReadOnly>{valor(postulante.comentarioEvaluador, postulante.ComentarioEvaluador, '-')}</ReadOnly>
                        </div>

                        <Actions>
                            <button type="button" className="generic-button-buscador"
                                    disabled={enviando} onClick={() => setMostrarObservacion(true)}>Observar</button>
                            <button type="button"
                                    className="generic-button-buscador generic-button-hover-verde green-innova-background"
                                    disabled={enviando} onClick={() => registrarResultado(ESTADO_APTO)}>Apto</button>
                            <button type="button" className="generic-button-buscador generic-button-hover-rojo"
                                    disabled={enviando} onClick={() => registrarResultado(ESTADO_NO_APTO)}>No apto</button>
                        </Actions>

                        {mostrarObservacion &&
                            <Overlay>
                                <ObservationBox>
                                    <h5>Ingresar observación</h5>
                                    <textarea className="form-control" rows="5" value={motivo}
                                              onChange={e => setMotivo(e.target.value)}
                                              placeholder="Ingrese el motivo de la observación..." />
                                    <ObservationActions>
                                        <button type="button" className="generic-button-buscador"
                                                onClick={() => setMostrarObservacion(false)}>Cancelar</button>
                                        <button type="button"
                                                className="generic-button-buscador generic-button-hover-verde green-innova-background"
                                                disabled={enviando || !motivo.trim()}
                                                onClick={() => registrarResultado(ESTADO_OBSERVADO, motivo)}>Enviar</button>
                                    </ObservationActions>
                                </ObservationBox>
                            </Overlay>
                        }
                    </>
                )}
            </Container>
        </GenericModal>
    );
};

export default RevisionClaseModelo;

const Container = styled.div`padding: 0 16px 18px; position: relative;`;
const CampaignBar = styled.div`background: #0645ff; color: #fff; padding: 10px 12px; font-weight: 600; margin-bottom: 24px;`;
const Divider = styled.div`border-top: 2px solid #0645ff; margin: 18px 0;`;
const SectionTitle = styled.div`display: inline-block; background: #0645ff; color: #fff; padding: 7px 12px; font-weight: 600; margin-bottom: 14px;`;
const Grid = styled.div`display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px 24px; @media (max-width: 760px) { grid-template-columns: 1fr; }`;
const Field = styled.div`label { display: block; font-size: 12px; margin-bottom: 4px; }`;
const ReadOnly = styled.div`background: #f1f1f1; min-height: 32px; padding: 7px 9px;`;
const FileRow = styled.div`cursor: pointer; margin-bottom: 12px;`;
const Actions = styled.div`display: flex; justify-content: center; gap: 20px; margin-top: 24px; button { min-width: 150px; }`;
const Overlay = styled.div`position: absolute; inset: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; z-index: 10;`;
const ObservationBox = styled.div`background: #fff; width: 520px; max-width: 92%; padding: 20px; border-radius: 4px;`;
const ObservationActions = styled.div`display: flex; justify-content: flex-end; gap: 12px; margin-top: 14px;`;